import { PayoutTransferStatus } from "@modules/finances/types/financesType"
import { z } from "zod"

export const FinanceStatisticsDtoSchema = z.object({
  totalTransactionsValue: z.number(),
  totalTransactionsCurrency: z.string(),
  activeMembersNumber: z.number(),
  pendingBalanceForTransfer: z.number().nullable(),
  availableBalanceForTransfer: z.number().nullable(),
  transferArrivalDate: z.string().nullable(),
  transferStatus: z.nativeEnum(PayoutTransferStatus).nullable(),
  transferAmount: z.number().nullable(),
})

export type FinanceStatisticsDto = z.infer<typeof FinanceStatisticsDtoSchema>
